/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InstallmentPlanCsvReportRequest } from '../models/InstallmentPlanCsvReportRequest';
import type { InstallmentPlanDto } from '../models/InstallmentPlanDto';
import type { UploadConfirmResponse } from '../models/UploadConfirmResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PartnerInstallmentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns UploadConfirmResponse OK
     * @throws ApiError
     */
    public generateCsvInstallmentPlansReport1({
        requestBody,
    }: {
        requestBody: InstallmentPlanCsvReportRequest,
    }): CancelablePromise<UploadConfirmResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partner-apis/installments/csv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns InstallmentPlanDto OK
     * @throws ApiError
     */
    public confirmCreate({
        requestBody,
    }: {
        requestBody: InstallmentPlanDto,
    }): CancelablePromise<InstallmentPlanDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partner-apis/installments/confirm-create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
